import { environment } from '../environments/environment';
// import { Plugins } from '@capacitor/core';
// const { Device } = Plugins;
import { Network } from '@capacitor/network';
import { Device } from '@capacitor/device';
import * as Enums from './constants';
import { Version } from '@angular/compiler';
import { App } from '@capacitor/app';
// Don't annotate it with @Injectable() ! It's a simple class.
// This class will create function which are not dependent on any of the services or modules
// This class is purely design foe some custom/helpers functions without dependency
export abstract class BaseService {

  _month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  appVersion: any;
  globalInitURL: any;
  packageId: any;

  constructor() {
    this.getDeviceInfo();
  }
  log(value: any, type?: string) {
    // type [info,error,log,warn,debug]
    if (!environment.production) {
      if (type === 'error')
        console.error(value);
      else if (type === 'warn')
        console.warn(value);
      else
        console.log(value);
    }
  }
  getTicketTags(object) {
    let formEle = {
      wallettxnid: {
        id: 'wallettxnid',
        key: 'wallettxnid',
        type: 'input',
        label: 'Wallet Txn ID',
        placeholder: Enums.CONSTANTS.FORMLY_PLACEHOLDER_TEXT,
        description: 'Wallet Txn ID',
        options: null,
        maxLength: 50,
        hideExpression: null,
        group:'1'
      }, paymode: {
        id: 'paymode',
        key: 'paymode',
        type: 'input',
        label: 'Payment Mode',
        placeholder: Enums.CONSTANTS.FORMLY_PLACEHOLDER_TEXT,
        description: 'Payment Mode',
        options: null,
        maxLength: 50,
        hideExpression: null,
        group:'1'
      }, payac: {
        id: 'payac',
        key: 'payac',
        type: 'input',
        label: 'Payment Account',
        placeholder: Enums.CONSTANTS.FORMLY_PLACEHOLDER_TEXT,
        description: 'Payment Account',
        options: null,
        maxLength: 50,
        hideExpression: null,
        group:'1'
      }, paytxnid: {
        id: 'paytxnid',
        key: 'paytxnid',
        type: 'input',
        label: 'Payment Txn ID',
        placeholder: Enums.CONSTANTS.FORMLY_PLACEHOLDER_TEXT,
        description: 'Payment Txn ID',
        options: null,
        maxLength: 50,
        hideExpression: null,
        group:'1'
      }, paybank: {
        id: 'paybank',
        key: 'paybank',
        type: 'input',
        label: 'Payee Bank',
        placeholder: Enums.CONSTANTS.FORMLY_PLACEHOLDER_TEXT,
        description: 'Payee Bank',
        options: null,
        maxLength: 50,
        hideExpression: null,
        group:'1'
      }, payts: {
        id: 'payts',
        key: 'payts',
        type: 'date',
        label: 'Payment Date',
        placeholder: Enums.CONSTANTS.FORMLY_PLACEHOLDER_TEXT,
        description: 'Payment Date',
        options: null,
        hideExpression: null,
        group:'1'
      }, vrn: {
        id: 'vrn',
        key: 'vrn',
        type: 'select',
        label: 'VRN',
        placeholder: Enums.CONSTANTS.FORMLY_PLACEHOLDER_TEXT,
        description: 'VRN',
        maxLength: 50,
        options: object.vrn,
        hideExpression: null,
        group:'2'
      }, addr: {
        id: 'addr',
        key: 'addr',
        type: 'input',
        label: 'Address',
        placeholder: Enums.CONSTANTS.FORMLY_PLACEHOLDER_TEXT,
        description: 'Address',
        options: null,
        maxLength: 50,
        hideExpression: null,
        group:'1'
      }, email: {
        id: 'email',
        key: 'email',
        type: 'email',
        label: 'Email',
        placeholder: Enums.CONSTANTS.FORMLY_PLACEHOLDER_TEXT,
        description: 'Email',
        options: null,
        maxLength: 50,
        hideExpression: null,
        group:'1'
      }, phone: {
        id: 'phone',
        key: 'phone',
        type: 'number',
        label: 'Phone',
        placeholder: Enums.CONSTANTS.FORMLY_PLACEHOLDER_TEXT_PHONE,
        description: 'Phone',
        options: null,
        maxLength: 10,
        hideExpression: null,
        group:'1'
      }, name: {
        id: 'name',
        key: 'name',
        type: 'input',
        label: 'Name',
        placeholder: Enums.CONSTANTS.FORMLY_PLACEHOLDER_TEXT,
        description: 'Name',
        options: null,
        maxLength: 50,
        hideExpression: null,
        group:'1'
      }, tolltxnid: {
        id: 'tolltxnid',
        key: 'tolltxnid',
        type: 'input',
        label: 'Toll Txn ID',
        placeholder: Enums.CONSTANTS.FORMLY_PLACEHOLDER_TEXT,
        description: 'Toll Txn ID',
        options: null,
        maxLength: 50,
        hideExpression: null,
        group:'1'
      }, remarks:{
        id: 'remarks',
        key: 'remarks',
        type: 'textarea',
        label: 'Remarks',
        placeholder: 'You comments',
        description: 'Remarks',
        options: null,
        maxLength: 199,
        hideExpression: null,
        group:'2'
      },reasonCode:{
        id: 'reasonCode',
        key: 'reasonCode',
        type: 'select',
        label: 'Reason Code',
        placeholder: 'Reason Code',
        description: 'Reason Code',
        options: null,
        maxLength: 50,
        hideExpression: null,
        group:'2',
        defaultval:''
      },acqTxnId:{
        id: 'acqTxnId',
        key: 'acqTxnId',
        type: 'input',
        label: 'Txn ID',
        placeholder: 'Txn ID',
        description: 'Txn ID',
        options: null,
        maxLength: 50,
        hideExpression: null,
        group:'1',
        defaultval:''
      },fullPartialIndicator:{
        id: 'fullPartialIndicator',
        key: 'fullPartialIndicator',
        type: 'radio',
        label: 'Refund Type',
        placeholder: 'Refund Type',
        description: 'Refund Type',
        options: [{
          val:'F',label:'Full'
        },{
          val:'P',label:'Partial'
        }],
        maxLength: 1,
        hideExpression: null,
        group:'2',
        defaultval:'F'
      },txnAmount:{
        id: 'txnAmount',
        key: 'txnAmount',
        type: 'number',
        label: 'Txn Amount',
        placeholder: 'Txn Amount',
        description: 'Txn Amount',
        options: null,
        maxLength: 10,
        hideExpression: null,
        group:'1',
        defaultval:'0'
      },remark:{
        id: 'remark',
        key: 'remark',
        type: 'textarea',
        label: 'Remarks',
        placeholder: 'You comments',
        description: 'Remarks',
        options: null,
        maxLength: 199,
        hideExpression: null,
        group:'2',
        defaultval:''
      }
    };
    return formEle;
  }

  getDisputeDefaultForm_DELETE(obj){
    let commonFileds: any = [
      {
        className: 'templet',
        fieldGroupClassName: 'display-flex',
        fieldGroup: [
          {
            className: 'flex-2',
            template: '<hr /><h5><ion-label class="formly-lbl">' + 'Txn Id ' + '<span class="required-asterisk">' + '*' + '</span></ion-label></h5>',
          },
        ],
      },
      {
        fieldGroupClassName: 'display-flex',
        fieldGroup: [
          {
            className: 'flex',
            key: 'acqTxnId',
            type: 'input',
            templateOptions: {
              label: '',
              placeholder: 'Txn Id',
              description: 'Txn Id',
              required: true,
              hideRequiredMarker: true
            },
          }
        ],
      },
      {
        className: 'templet',
        fieldGroupClassName: 'display-flex',
        fieldGroup: [
          {
            className: 'flex-2',
            template: '<hr /><h5><ion-label class="formly-lbl">' + 'Txn Amount ' + '<span class="required-asterisk">' + '*' + '</span></ion-label></h5>',
          },
        ],
      },
      {
        fieldGroupClassName: 'display-flex',
        fieldGroup: [
          {
            className: 'flex',
            key: 'txnAmount',
            type: 'input',
            //defaultValue: obj?.txn_amount,
            templateOptions: {
              label: '',
              type: 'number',
              min: 1,
              placeholder: 'Txt amount',
              description: 'txt amount',
              required: true,
              hideRequiredMarker: true
            },
          }
        ],
      },
      {
        className: 'templet',
        fieldGroupClassName: 'display-flex',
        fieldGroup: [
          {
            className: 'flex-2',
            template: '<hr /><h5><ion-label class="formly-lbl">' + 'Refund Type' + '<span class="required-asterisk">' + '*' + '</span></ion-label></h5>',
          },
        ],
      },
      {
        fieldGroupClassName: 'display-flex',
        fieldGroup: [
          {
            className: 'flex',
            key: 'fullPartialIndicator',
            type: 'radio',
            defaultValue: 'F',
            templateOptions: {
              label: 'Select refund type',
              placeholder: 'Placeholder',
              description: 'Description',
              required: true,
              options: [
                { value: 'F', label: 'Full Refund' },
                { value: 'P', label: 'Partial Refund' }
              ],
            },
          }
        ],
      },
      {
        fieldGroupClassName: 'display-flex',
        fieldGroup: [],
      },
      {
        className: 'templet',

        fieldGroupClassName: 'display-flex',
        fieldGroup: [
          {
            className: 'flex-2',
            template: '<hr /><h5><ion-label class="formly-lbl">' + 'Remark' + '<span class="required-asterisk">' + '*' + '</span></ion-label></h5>',
          },
        ],
      },
      {
        fieldGroupClassName: 'display-flex',
        fieldGroup: [
          {
            className: 'flex',
            key: 'remarks',
            type: 'textarea',
            templateOptions: {
              class: 'textarea-formly',
              label: null,
              placeholder: '',//'Write your remark',
              description: 'Remark',
              maxLength: 199,
              required: true,
              hideRequiredMarker: true
            },
          }
        ],
      },


    ];
    return commonFileds;
  }
  getDefaultForm() {
    let commonFileds: any = [
      {
        fieldGroupClassName: 'display-flex',
        fieldGroup: [],
      },
      {
        className: 'templet',

        fieldGroupClassName: 'display-flex',
        fieldGroup: [
          {
            className: 'flex-2',
            template: '<hr /><h5><ion-label class="formly-lbl">' + 'Remark' + '<span class="required-asterisk">' + '*' + '</span></ion-label></h5>',
          },
        ],
      },
      {
        fieldGroupClassName: 'display-flex',
        fieldGroup: [
          {
            className: 'flex',
            key: 'remarks',
            type: 'textarea',
            templateOptions: {
              class: 'textarea-formly',
              label: null,
              placeholder: '',//'Write your remark',
              description: 'Remark',
              maxLength: 199,
              required: true,
              hideRequiredMarker: true
            },
          }
        ],
      },
      /*{
        className: 'templet',
 
        fieldGroupClassName: 'display-flex',
        fieldGroup: [
          {
            className: 'flex-2',
            template: '<hr /><h5><ion-label>Attachment:</ion-label></h5>',
          },
        ],
      },
      {
        className: 'display-flex flex',
        key: 'file',
        type: 'file',
      },*/

    ];
    return commonFileds;
  }
  async getDeviceInfo() {
    const info = await Device.getInfo();
    localStorage.setItem("platformDetail", info.platform);
    return info;
  }

  getAppVersion() {
    return (localStorage.getItem("appVersion") !== null) ? localStorage.getItem("appVersion") : null;

  }

  setAppVersion() {
    if (localStorage.getItem("appVersion") === null) {
      const version = environment.appVersion;
      localStorage.setItem("appVersion", version);
    }
  }

  getLocalPlatformDetail() {
    return (localStorage.getItem("platformDetail") !== null) ? localStorage.getItem("platformDetail") : null;
  }

  getglobalInitURL() {
    return (localStorage.getItem("globalInitURL") !== null) ? localStorage.getItem("globalInitURL") : null;
  }

  setglobalInitURL() {
    if (localStorage.getItem("globalInitURL") === null) {
      const globalInit = Enums.CONSTANTS.GLOBAL_INIT_URL;
      localStorage.setItem("globalInitURL", globalInit);
    }
  }

  getpackageId() {
    return (localStorage.getItem("packageId") !== null) ? localStorage.getItem("packageId") : null;
  }

  setpackageId() {
    if (localStorage.getItem("packageId") === null) {
      const packageId = environment.packageId;
      localStorage.setItem("packageId", packageId);
    }
  }

  setFCMToken(token) {
    localStorage.setItem("fcmToken", token);
  }

  getFCMToken() {
    return (localStorage.getItem("fcmToken") !== null) ? localStorage.getItem("fcmToken") : null;
  }

  getDisplayDtTm(dateTime) {
    const date = new Date(dateTime);
    const dd = date.getDate();
    const mm = this._month[date.getMonth()];
    const Y = date.getFullYear();
    const timing = date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
    return dd + ' ' + mm + ' ' + Y + ', ' + timing;
  }

  async isOnLine_1() {
    const status = await Network.getStatus();
    return status.connected;
    //console.log('Network status:', status);
    // if (status.onLine) {
    //     return true;
    // } else {
    //     return false;
    // }
  }

  isOnLine() {
    return navigator.onLine;
  }

  // This functions return the current date in timestamp
  getTimestamp() {
    const date = new Date();
    const timeStamp = date.toISOString();
    //this.log(new Date().toISOString() + '<: timeStamp :>' + timeStamp);
    return new Date().toISOString();
  }

  differenceInDays(date1: any, date2: any) {
    const dt1 = new Date(date1);
    const dt2 = new Date(date2);
    return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
  }

  differenceInMinutes(date1, date2) {
    const dt1 = new Date(date1);
    const dt2 = new Date(date2);
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;

    return Math.abs(Math.round(diff));
  }

  // Takes the date in new Date().toISOString(); format
  isBetweenDate(from, to, check) {
    var fDate, lDate, cDate;
    fDate = Date.parse(from.substring(0, 10));
    lDate = Date.parse(to.substring(0, 10));
    cDate = Date.parse(check.substring(0, 10));

    if ((cDate <= lDate && cDate >= fDate)) {
      return true;
    }
    return false;
  }


  sortEntities(sortOn: any, taskList: any, order: any) {
    if (sortOn === 'id') {
      taskList.sort(this.prioritySort(sortOn, order));
    } else {
      taskList.sort(this.stringSort(sortOn, order));
    }
    return taskList;
  }

  prioritySort = (field, order) => {
    if (order === "asc") {
      return (x, y) => {
        return x[field] - y[field];
      };
    } else if (order === "desc") {
      return (x, y) => {
        return y[field] - x[field];
      };
    }
  };

  stringSort = (field, order) => {
    if (order === "asc") {
      return (x, y) => {
        return x[field].toLowerCase() > y[field].toLowerCase() ? 1 : -1;
      };
    } else if (order === "desc") {
      return (x, y) => {
        return y[field].toLowerCase() > x[field].toLowerCase() ? 1 : -1;
      };
    }
  };

  ifUrlPresent(stringVal) {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    let urlString = null;
    stringVal.replace(urlRegex, (url) => {
      urlString = url;
    });
    return urlString;
  }

  mapColData(col, records) {
    let data = [];
    records.forEach((record, i) => {
      let recObj = {};
      record.forEach((val, key) => {
        let k = col[key];
        recObj[k] = val;
      });
      data.push(recObj);
    });
    return data;
  }

  getLocalUserId() {
    return (localStorage.getItem("userId") !== null) ? localStorage.getItem("userId") : null;
  }

  getLocalAuthToken() {
    return (localStorage.getItem("authToken") !== null) ? localStorage.getItem("authToken") : null;
  }

  getLocalVehicleList() {
    return (localStorage.getItem("vehicleList") !== null) ? JSON.parse(localStorage.getItem("vehicleList")) : null;
  }

  getLocalVehicleListSorted() {
    return (localStorage.getItem("vehicleListSorted") !== null) ? JSON.parse(localStorage.getItem("vehicleListSorted")) : null;
  }

  getLocalsubCat() {
    return (localStorage.getItem("subCat") !== null) ? JSON.parse(localStorage.getItem("subCat")) : null;
  }

  getAppTheme() {
    return (localStorage.getItem("theme") !== null) ? localStorage.getItem("theme") : 'default';
  }

  setAppTheme(val) {
    localStorage.setItem("theme",val);
  }

  getLocalProfileData() {
    return (localStorage.getItem("profileData") !== null) ? JSON.parse(localStorage.getItem("profileData")) : null;
  }

  getLocalappGlobalInit() {
    return (localStorage.getItem("globalInit") != null) ? localStorage.getItem("globalInit") : 'null';
  }

  getLocalgetDeviceInfo() {
    return (localStorage.getItem("deviceInfo") != null) ? JSON.parse(localStorage.getItem("deviceInfo")) : 'null';
  }

  getLocalresetPwdURL() {
    return (localStorage.getItem("resetPwdURL") != null) ? localStorage.getItem("resetPwdURL") : 'null';
  }

  getLocalapiBaseURL() {
    return (localStorage.getItem("apiBaseURL") != null) ? localStorage.getItem("apiBaseURL") : null;
  }

  getLocalwebPageURL() {
    return (localStorage.getItem("webPageURL") != null) ? localStorage.getItem("webPageURL") : 'null';
  }

  getLocalloginURL() {
    return (localStorage.getItem("loginURL") != null) ? localStorage.getItem("loginURL") : 'null';
  }

  getLocalfbKeyFile() {
    return (localStorage.getItem("fbKeyFile") != null) ? localStorage.getItem("fbKeyFile") : 'null';
  }

  getLocalgetAppVersion() {
    return (localStorage.getItem("appVersion") !== null) ? localStorage.getItem("appVersion") : null;
  }

  getLocalvehicleUpdateTime() {
    return (localStorage.getItem("vehicleUpdateTime") !== null) ? new Date(localStorage.getItem("vehicleUpdateTime")) : null;
  }

  getLocalDashboardUpdatedTime() {
    return (localStorage.getItem("dashboardUpdatedTime") !== null) ? new Date(localStorage.getItem("dashboardUpdatedTime")) : null;
  }

  getLocalglobalInitURL() {
    return (localStorage.getItem("globalInitURL") !== null) ? localStorage.getItem("globalInitURL") : null;
  }

  getLocalpackageId() {
    return (localStorage.getItem("packageId") !== null) ? localStorage.getItem("packageId") : null;
  }

  getLocalVehicleClass() {
    return (localStorage.getItem("vehicleClass") !== null) ? JSON.parse(localStorage.getItem("vehicleClass")) : null;
  }

  getLocaltotalVehicles() {
    return (localStorage.getItem("totalVehicles") !== null) ? JSON.parse(localStorage.getItem("totalVehicles")) : null;
  }

  setTempTransactionID(txn_id) {
    localStorage.setItem("pg_txn_id", txn_id);
  }

  getTempTransactionID() {
    return (localStorage.getItem("pg_txn_id") !== null) ? localStorage.getItem("pg_txn_id") : null;
  }

  getOtpId() {
    return (localStorage.getItem("otpid") !== null) ? localStorage.getItem("otpid") : null;
  }
  
  getLastThreeMonthDate(subDays) {
    const today = new Date();
    const dd = today.getDate();
    const mm = today.getMonth() + 1;
    const Y = today.getFullYear();
    //const subDays = Enums.CONSTANTS.SUBTRACT_DAYS;
    today.setDate(today.getDate() - subDays);
    const M = today.getMonth() + 1;

    return today.toISOString().substr(0, 10);
  }

  findOcc(obj: any, key) {
    let arr = [];
    if (typeof obj === 'object') {
      for (const property in obj) {
        arr.push(obj[property]);
      }
    } else {
      arr = obj;
    }

    let arr2 = [];
    arr.forEach((x, index) => {
      // Checking if there is any object in arr2
      // which contains the key value
      if (arr2.some((val) => { return val[key] == x[key] })) {
        // If yes! then increase the occurrence by 1
        arr2.forEach((k) => {
          if (k[key] === x[key]) {
            k["occurrence"]++
          }
        })
      } else {
        // If not! Then create a new object initialize 
        // it with the present iteration key's value and 
        // set the occurrence to 1
        let a = {}
        a[key] = x[key]
        a["occurrence"] = 1
        arr2.push(a);
      }

    })

    return arr2
  }

  currencyFormatter(amount, format) {
    if (format == 'INR') {
      return "₹ " + parseInt(amount);
    }
    // removed below regex as IOS is givig error
    //return "₹" +parseInt(txn_amount).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
  }

}